import axios from "axios";
const API_URL = "https://zenbilling25.zentexus.com/api";
//http://localhost/zentexus_billing_api

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  mode: "no-cors",
});

export default axiosInstance;
